import { api } from "../../../services/api";
import React, { useEffect, useState } from "react";
import {
    Container,
    ElementContainer,
    Section,
} from "./../../../styles/Adm/IndexPages/styles";
import { StyledButton } from "./../../../styles/Adm/IndexPages/styles";
import { AiFillDelete } from "react-icons/ai";
import { MdEdit } from "react-icons/md";
import Button from "../../../components/Button";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const IndexProjectPage = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        api.get("/projects/")
            .then((response) => {
                setProjects(response.data);
            })
            .catch((e) => {
                const data = e?.response?.data;
                toast.error(
                    data?.error
                        ? data.error
                        : data?.message
                        ? data.message
                        : e.message
                );
            });
    }, []);

    const deleteProject = (id) => {
        let confirmDelete = window.confirm(
            "Tem certeza que quer excluir esse projeto?"
        );
        if (confirmDelete) {
            api.delete(`/projects/delete/${id}`)
                .then(() => {
                    toast.success("Projeto deletado");
                    setProjects((projects) =>
                        projects.filter((prj) => prj.id !== id)
                    );
                })
                .catch((er) => {
                    switch (er?.response?.status) {
                        case 401:
                            toast.error(
                                "O usuário não pode ser autenticado. Caso realmente seja um administrador, tente sair e entrar novamente na conta."
                            );
                            break;

                        default:
                            toast.error(er.message);
                            break;
                    }
                });
        }
    };

    return (
        <>
            <Section>
                <div className="title-container">
                    <h1> Gerencie seus Projetos </h1>
                </div>

                <div className="head-container">
                    <div className="table-titles">
                        <div className="containers">
                            <h2> Nome do Projeto </h2>
                        </div>
                        <div className="containers null-on-mobile">
                            <h2> Cliente </h2>
                        </div>
                        <div className="containers">
                            <h2> Ações </h2>
                        </div>
                    </div>
                </div>

                <Container>
                    {projects.map((item, index) => (
                        <ElementContainer key={item.id}>
                            <div className="containers">
                                <Link to={`./${item.id}`}>
                                    <span> {item.name} </span>
                                </Link>
                            </div>
                            <div className="containers null-on-mobile">
                                <span> {item.client_name} </span>
                            </div>
                            <div className="containers">
                                <Link to={`./editar/${item.id}`}>
                                    <StyledButton
                                        variant="contained"
                                        className="small-font"
                                        endIcon={<MdEdit size={14} />}
                                    >
                                        Editar
                                    </StyledButton>
                                </Link>
                                <StyledButton
                                    variant="contained"
                                    type="button"
                                    className="small-font"
                                    onClick={() => deleteProject(item.id)}
                                    endIcon={<AiFillDelete size={14} />}
                                >
                                    {" "}
                                    Excluir{" "}
                                </StyledButton>
                            </div>
                        </ElementContainer>
                    ))}
                </Container>

                <Link to="./criar">
                    <Button>Adicionar Projeto</Button>
                </Link>
            </Section>
        </>
    );
};
export default IndexProjectPage;